import { useEffect, useState } from 'react';
import { AppRouter } from './routes/AppRouter';
import { MaintenanceBanner } from './components/Shared/MaintenanceBanner';
import { useThemeStore } from './store/useThemeStore';
import { useAuthStore } from './store/useAuthStore';
import { useVersionPolling } from './hooks/useVersionPolling';

function App() {
  const { theme } = useThemeStore();
  const { checkAuth } = useAuthStore();
  const [isInitializing, setIsInitializing] = useState(true);

  useVersionPolling();

  // Initial auth validation beim App-Start
  useEffect(() => {
    const initializeAuth = async () => {
      // Prüfe ob ein Token im localStorage existiert
      const stored = localStorage.getItem('auth-storage');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (parsed.state?.isAuthenticated) {
            // Validiere den Token via /me endpoint
            await checkAuth();
          }
        } catch (error) {
          console.error('Auth initialization error:', error);
          // Bei Fehler wird der State in checkAuth bereinigt
        }
      }
      setIsInitializing(false);
    };

    initializeAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  // Zeige Loading während der initialen Auth-Validierung
  if (isInitializing) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-accent-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
          <p className="text-sm text-gray-600 dark:text-gray-400">FacilityFlow wird geladen...</p>
        </div>
      </div>
    );
  }

  // Banner außerhalb des Routers: es muss auch auf /login und den öffentlichen
  // Seiten erscheinen — dort fällt ein Ausfall zuerst auf.
  return (
    <>
      <MaintenanceBanner />
      <AppRouter />
    </>
  );
}

export default App;
